import React, { useEffect, useState } from "react";
import Breadcrumbs from "../layout/breadcrumb";
import Filter from "../../assets/Icons/filter.png";
import Download from "../../assets/Icons/download.png";
import { DPR_API } from "../../services/apiCalls/dprApiCalls";
import Close from "../../assets/Images/close.png";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import leftArrow from "../../assets/Images/left-arrow.png";
import rightArrow from "../../assets/Images/right-arrow.png";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import IssueRegisterForm from "./issue-register-form";
import "./issue.css";
import DprHeader from "../layout/dprHeader";
import { useLocation } from "react-router-dom";
import ExcelExport from "../../compnenets/commons/xls";

export default function Issuelist() {
  const location = useLocation();
  const pro = location.state || {};
  const [openFilter, setOpenFilter] = useState(false);
  const onCloseModalFilter = () => setOpenFilter(true);
  const [open, setOpen] = useState(false);
  const onCloseModal = () => setOpen(true);

  const [issueList, setIssueList] = useState([]);
  const [issueFilter, setIssueFilter] = useState({
    StartDate: "",
    EndDate: "",
    Activity_task: "",
    IssueStatus: "",
  });

  const getIssueData = async (filterdata = {}) => {
    console.log(filterdata, "heyyyy");
    console.log(issueFilter, "---");
    const state = JSON.parse(localStorage.getItem("state"));
    setCurrentPage(1);

    let obj = {
      ...(Object.keys(filterdata).length === 0
        ? { UserID: state.user.user_id }
        : {}),
      ...filterdata,
    };

    const issue = await DPR_API.GetIssueAllocationDetails(obj);

    if (issue.status === 200) {
      setIssueList(issue.IssueList);
    } else {
      setIssueList([]);
    }
  };

  useEffect(() => {
    getIssueData();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(issueList.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = issueList.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const handleRowClick = (rowData) => {
    setSelectedRowData(rowData);
    setActiveTabIndex(1);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setIssueFilter((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const onSubmit = () => {
    setActiveTabIndex(0);
    getIssueData();
  };
  return (
    <React.Fragment>
      <Breadcrumbs title="Issue Register" menu="" link="Issue Register" />
      <DprHeader project={pro} />
      <div className="pb-5 mt-3">
        <div className="card card-none">
          <div className="card-body" id="risk-register">
            <Tabs
              selectedIndex={activeTabIndex}
              onSelect={(index) => setActiveTabIndex(index)}
            >
              <TabList>
                <Tab>Issue Register List</Tab>
                <Tab>Issue Register Form</Tab>
              </TabList>
              <hr />
              <TabPanel>
                <div className="row" style={{ marginRight: 25 }}>
                  <div className="d-flex justify-content-end">
                    <div className="download-icon">
                      <ExcelExport
                        data={issueList}
                        fileName="Issue List"
                        sheet="Issue List"
                      />
                    </div>
                    <div className="filter-icon mx-2 my-auto">
                      <img
                        className=""
                        onClick={() => {
                          setOpenFilter(true);
                        }}
                        src={Filter}
                        width={20}
                      />
                    </div>
                    <div
                      className="my-auto"
                      onClick={() => {
                        getIssueData();
                        setIssueFilter({
                          StartDate: "",
                          EndDate: "",
                          Activity_task: "",
                          IssueStatus: "",
                        });
                        setCurrentPage(1);
                      }}
                    >
                      <span
                        style={{
                          cursor: "pointer",
                          fontSize: 12,
                          fontWeight: 500,
                          background: "#8add79f7",
                          padding: 5,
                          borderRadius: 12,
                        }}
                      >
                        Clear filters
                      </span>
                    </div>
                  </div>
                </div>
                <div className="table-container">
                  <table className="custom-table">
                    <thead className="table-header">
                      <tr>
                        <th>Sr No</th>
                        <th>Project Name</th>
                        <th>Product Category</th>
                        <th>Project Location</th>
                        <th>Issue Description</th>
                        <th>Impact Description</th>
                        <th>Created Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedData.map((row, index) => (
                        <tr
                          key={index}
                          onClick={() => handleRowClick(row)}
                          style={{ cursor: "pointer" }}
                        >
                          <td>{index + 1 + (currentPage - 1) * 10}</td>
                          <td id="elps" title={row.ProjectName}>
                            {row.ProjectName}
                          </td>
                          <td id="elps" title={row.ProductCategory}>
                            {row.ProductCategory}
                          </td>
                          <td id="elps" title={row.Location}>
                            {row.Location}
                          </td>
                          {/* <td id="elps" title={row.Activity}>
                            {row.Activity}
                          </td> */}
                          <td id="elps" title={row.ImpactDescription}>
                            {row.ImpactDescription}
                          </td>
                          <td id="elps" title={row.ImpactDescription}>
                            {row.ImpactDescription}
                          </td>
                          <td>
                            {new Date(row?.CreatedOn).toLocaleDateString(
                              "en-GB"
                            )}
                          </td>
                          {/* <td style={{ cursor: 'pointer' }}>
                                <img src={Add} width={20} onClick={onOpenModal} />
                            </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div
                    className="pagination"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "10px 15px",
                    }}
                  >
                    <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                      Showing{" "}
                      {Math.min(
                        (currentPage - 1) * rowsPerPage + 1,
                        issueList.length
                      )}{" "}
                      to {Math.min(currentPage * rowsPerPage, issueList.length)}{" "}
                      of {issueList.length} entries
                    </div>

                    <div
                      className="pagination-buttons"
                      style={{
                        fontSize: "14px",
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%",
                        gap: "5px",
                      }}
                    >
                      {/* Left Arrow */}
                      <button
                        onClick={() =>
                          handleClick(Math.max(1, currentPage - 1))
                        }
                        disabled={currentPage === 1}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: currentPage === 1 ? "not-allowed" : "pointer",
                        }}
                      >
                        <img
                          src={leftArrow} // Replace with your actual image path
                          alt="Previous"
                          height="11px"
                          width="7px"
                          style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
                        />
                      </button>

                      {/* Page Numbers */}
                      {[...Array(totalPages)].map((_, i) => (
                        <button
                          key={i}
                          onClick={() => handleClick(i + 1)}
                          style={{
                            background:
                              currentPage === i + 1 ? "#00B69B" : "transparent",
                            color: currentPage === i + 1 ? "#fff" : "#000",
                            border: "none",
                            borderRadius: "50%",
                            width: "30px",
                            height: "30px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          {i + 1}
                        </button>
                      ))}

                      {/* Right Arrow */}
                      <button
                        onClick={() =>
                          handleClick(Math.min(totalPages, currentPage + 1))
                        }
                        disabled={currentPage === totalPages}
                        style={{
                          background: "none",
                          border: "none",
                          cursor:
                            currentPage === totalPages
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <img
                          src={rightArrow} // Replace with your actual image path
                          alt="Next"
                          height="11px"
                          width="7px"
                          style={{
                            opacity: currentPage === totalPages ? 0.5 : 1,
                          }}
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="row">
                  <div className="col-6">
                    <IssueRegisterForm
                      rowData={selectedRowData}
                      onSubmit={onSubmit}
                    />
                  </div>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
      <Modal open={openFilter} onClose={onCloseModalFilter} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Issue Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpenFilter(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <label className="filter-label">Start date</label>
                  <input
                    type="date"
                    onChange={handleChange}
                    value={issueFilter.StartDate}
                    name="StartDate"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End date</label>
                  <input
                    type="date"
                    onChange={handleChange}
                    value={issueFilter.EndDate}
                    name="EndDate"
                    className="form-control shadow-none"
                  />
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Activity/Task</label>
                  <input
                    type="text"
                    onChange={handleChange}
                    value={issueFilter.Activity_task}
                    name="Activity_task"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">Issue Status</label>
                  <select
                    className="filter-label"
                    onChange={handleChange}
                    value={issueFilter.IssueStatus}
                    name="IssueStatus"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option>Select</option>
                    <option value="Open">Open</option>
                    <option value="Resolved">Resolved</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: 20 }}>
              <span className="resorces">Sort Issue</span>
            </div>
            <div style={{ marginRight: 20 }}>
              <select
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option>ASC</option>
                <option>DES</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginLeft: 20 }}>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Role"
              value="option1"
            />
            <label for="Role" style={{ fontSize: 14 }}>
              Impact level
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Type"
              value="option1"
            />
            <label for="Type" style={{ fontSize: 14 }}>
              Priority Level
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Created"
              value="option1"
            />
            <label for="Created" style={{ fontSize: 14 }}>
              Created date
            </label>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            className="btn btn-primary"
            onClick={() => {
              setIssueFilter((prevFilter) => {
                const updatedFilter = {
                  ...prevFilter,
                };

                getIssueData(updatedFilter);
                setCurrentPage(1);
                return updatedFilter;
              });
              setOpenFilter(false);
            }}
          >
            Filter
          </button>
        </div>
      </Modal>
      <Modal open={open} onClose={onCloseModal} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="allowcate">Assign to Concerned Person</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpen(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row mt-2">
          <div>
            <label className="filter-label">Email</label>
            <input
              type="email"
              className="form-control shadow-none"
              placeholder="Email"
            />
          </div>
          <div className="d-flex justify-content-center mt-4">
            <button className="btn btn-primary">Send</button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
}
